import { HTML_LINK_TARGET } from '../../../../constants/html'
import { MultiValuedListItem } from '../../../MultiValuedList'
import { Link } from '../../Link'

import * as styles from './LinkMultiValuedListMoreItem.module.css'

function LinkMultiValuedListMoreItem({
  children,
  className = styles.LinkMultiValuedListMoreItem,
  disabled,
  to,
  unread,
  ...itemProps
}) {
  const linkProps = {
    children,
    disabled,
    to,
    unread,
  }

  return children ? (
    <MultiValuedListItem {...itemProps} className={className}>
      <Link {...linkProps} target={HTML_LINK_TARGET.blank} />
    </MultiValuedListItem>
  ) : null
}

export default LinkMultiValuedListMoreItem
